module.exports = __webpack_public_path__ + "img/yes-br.01c76bbf.png";